export default __webpack_public_path__ + "fonts/Aeonik-Regular_2b087101b2a637d6ee139e833c3cbea3.woff2";